import PropTypes from 'prop-types';
import { Button, IconHighlight } from '@aimsos/ui';

import { Filter } from 'lucide-react';

/**
 * `FILTERS` with nothing in it (CT-5193).
 *
 * The design source of truth gives this its own block rather than a footnote: a
 * dashed-bordered panel, centred, with the icon, the two lines and the primary
 * action inside it. Reading "no filters" and reaching for `Add filter` is one
 * glance, and the dashed edge reads as "this area is empty and can be filled"
 * where a solid one would read as a populated card.
 *
 * Local rather than `StatusMessage`: that component hard-codes `py-16` and has
 * no action slot, so it is a page-sized empty state, not a section-sized one.
 */
function FiltersEmptyState({ title, subtitle, addLabel, onAdd }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-edge px-6 py-5 text-center">
      <IconHighlight icon={Filter} bgColor="Primary" iconColor="PrimaryAlt" size="small" />

      <div className="flex flex-col gap-1">
        <p className="m-0 text-sm font-semibold text-content">{title}</p>
        <p className="m-0 text-xs text-content-muted">{subtitle}</p>
      </div>

      <Button variant="primary" size="sm" onClick={onAdd}>
        {addLabel}
      </Button>
    </div>
  );
}

FiltersEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  addLabel: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default FiltersEmptyState;
